import { parseVirtualSessionError } from './useVirtualSessionPermissions';
import type { ParsedSessionError } from './useVirtualSessionPermissions';
import { useOnDemandSession } from '../activities';

const useOndemandSessionPermissions = ({
    eventId,
    sessionId,
    enabled = false,
}: UseOndemandSessionPermissionsProps): ParsedSessionError => {
    const { error } = useOnDemandSession({
        eventId,
        sessionId,
        options: {
            enabled: enabled && !!eventId && !!sessionId,
            refetchOnWindowFocus: false,
            notifyOnChangeProps: ['error'],
            retryOnMount: false,
        },
    });

    const parsedError = parseVirtualSessionError(error);

    return parsedError;
};

interface UseOndemandSessionPermissionsProps {
    eventId: number;
    sessionId: number;
    enabled?: boolean;
}

export default useOndemandSessionPermissions;
